import { highArmorNuggetsColumn } from "../resource/high-armor-nuggets-column";
import { NeededColumn } from "./needed-column";

export const highArmorNuggetNeededColumn = new NeededColumn(
  "44683e24-39b2-4e9c-b1da-d7fa25972730",
  highArmorNuggetsColumn,
  "Purp Nug Needed"
)
